import { render, staticRenderFns } from "./FloatBall.vue?vue&type=template&id=f54ba9ea&scoped=true"
import script from "./FloatBall.vue?vue&type=script&lang=js"
export * from "./FloatBall.vue?vue&type=script&lang=js"
import style0 from "./FloatBall.vue?vue&type=style&index=0&id=f54ba9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ba9ea",
  null
  
)

export default component.exports